var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.882 1.58301H10.5405V2.80658H14.2113H17.882V1.58301Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09326 2.80737H10.5404V4.03095H8.09326V2.80737Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8821 2.80737H20.3292V4.03095H17.8821V2.80737Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86987 4.03174H8.09345V5.25531H6.86987V4.03174Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3291 4.03174H21.5527V5.25531H20.3291V4.03174Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95215 5.2561H6.86983V7.04375H4.95215V5.2561Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5527 5.2561H22.7763V7.70484H21.5527V5.2561Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7764 7.70483H23.9999V15.051H22.7764V7.70483Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64648 15.051H6.87006V17.4998H5.64648V15.051Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5527 15.051H22.7763V17.4998H21.5527V15.051Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86987 17.4998H8.09345V18.7233H6.86987V17.4998Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3291 17.4998H21.5527V18.7233H20.3291V17.4998Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09326 18.7241H10.5404V19.9477H8.09326V18.7241Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8821 18.7241H20.3292V19.9477H17.8821V18.7241Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5405 19.9485H17.882V21.1721H10.5405V19.9485Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3934 8.4743L10.0136 8.14467L10.0136 8.1446L9.63603 7.81687L8.87645 7.15761L9.20682 6.77647L10.7238 8.0931L10.3934 8.4743ZM7.46624 7.25777L7.46618 7.25784L7.84379 7.58557L8.60337 8.24483L8.273 8.62597L6.93671 7.46618L6.93672 7.46617L6.75601 7.30933L7.08644 6.92813L7.46624 7.25777ZM4.99962 5.11708L4.66927 5.4982L4.28686 5.1663L3.90925 4.83856L3.90918 4.83865L3.1522 4.18165L3.48263 3.80045L4.99962 5.11708ZM3.93058 7.50954L4.58759 6.75158L4.76942 6.90939L5.52644 7.56642L4.86943 8.32439L3.93058 7.50954ZM4.85008 2.99507L4.51965 3.37627L3.00266 2.05964L3.33309 1.67843L4.85008 2.99507Z",
    fill: "#F4F3EB",
    stroke: "#F4F3EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restart-icon.dc6e9eae.svg";
export { ForwardRef as ReactComponent };